import React from 'react';

import { useIntl } from 'react-intl-next';

import Button, { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import messages from './messages';

interface UnsavedChangesModalProps {
	isOpen: boolean;
	onCreateWithoutSaving: () => void;
	onKeepEditing: () => void;
}

export const UnsavedChangesModal = ({
	isOpen,
	onKeepEditing,
	onCreateWithoutSaving,
}: UnsavedChangesModalProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();

	if (!isOpen) {
		return null;
	}

	return (
		<Modal onClose={onKeepEditing}>
			<ModalHeader>
				<ModalTitle>
					<Inline space="space.100" alignBlock="center">
						<StatusWarningIcon
							label={formatMessage(messages.modalTitle)}
							size="medium"
							spacing="spacious"
							color={token('color.icon.warning')}
						/>
						{formatMessage(messages.modalTitle)}
					</Inline>
				</ModalTitle>
				<IconButton
					appearance="subtle"
					icon={CrossIcon}
					label={formatMessage(messages.closeButton)}
					onClick={onKeepEditing}
				/>
			</ModalHeader>
			<ModalBody>{formatMessage(messages.modalDescription)}</ModalBody>
			<ModalFooter>
				<Button appearance="subtle" onClick={onKeepEditing}>
					{formatMessage(messages.keepEditingButton)}
				</Button>
				<Button appearance="warning" onClick={onCreateWithoutSaving}>
					{formatMessage(messages.leaveWithoutSavingButton)}
				</Button>
			</ModalFooter>
		</Modal>
	);
};
